import React from 'react'
import PropTypes from 'prop-types'
import { useNavBarLogic } from './NavBar.logic'
import { NavBarView } from './NavBar.view'

const NavBar = ({ onToggleSidebar, isSidebarShown }) => {
  const logic = useNavBarLogic()

  return (
    <NavBarView
      isSidebarShown={isSidebarShown}
      onToggleSidebar={onToggleSidebar}
      {...logic}
    />
  )
}

NavBar.propTypes = {
  onToggleSidebar: PropTypes.func.isRequired,
  isSidebarShown: PropTypes.bool.isRequired,
}

export default NavBar
